<template>
  <div>
    <h4 class="mb-4 bold text-overflow">Chuyển văn bản cho công ty</h4>
    <b-row class="mb-3">
      <b-col md="6" class="left-side p-0">
        <h6 class="bold mb-3">
          1. Chọn công ty và cá nhân bên dưới để chuyển văn bản
        </h6>
        <div class="w-100 mr-3">
          <el-form
            ref="formSearchCompany"
            :model="mData.dataFormTransferToOtherCompany"
            :rules="mData.validFormTransferToOtherCompany"
            @submit.native.prevent
            label-position="top"
            style="border: none"
            v-show="tabName == 'CongTy'"
          >
            <el-form-item label="" prop="text_search_company">
              <el-input
                type="text"
                v-model="
                  mData.dataFormTransferToOtherCompany.text_search_company
                "
                placeholder="Tìm kiếm mã số thuế, số điện thoại cố định công ty hoặc email người liện hệ (Enter để tìm kiếm)"
                prefix-icon="fal fa-search"
                @keyup.enter.native="fn_getListDataByTab()"
              ></el-input>
            </el-form-item>
          </el-form>

          <el-form
            ref="formSearchPeople"
            :model="mData.dataFormVTOtherCompany"
            :rules="mData.validFormVTOtherCompany"
            @submit.native.prevent
            label-position="top"
            style="border: none"
            v-show="tabName !== 'CongTy'"
          >
            <el-form-item label="" prop="text_search_person">
              <el-input
                type="text"
                v-model="mData.dataFormVTOtherCompany.text_search_person"
                placeholder="Tìm kiếm mã nhân viên, email, tài khoản nhân viên (Enter để tìm kiếm)"
                prefix-icon="fal fa-search"
                @keyup.enter.native="fn_getListDataByTab()"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <!-- Start Tab -->
        <el-tabs
          type="border-card"
          v-model="tabName"
          @tab-click="fn_handleClickTab"
        >
          <!-- Start Tab CongTy -->
          <el-tab-pane name="CongTy">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon isax-house mr-2"></i>
                <span>Chọn công ty</span>
              </div>
            </span>
            <div
              v-if="listCompany.length == 0"
              class="text-center center-block"
            >
              <h5 class="empty__tab-text">Không có dữ liệu.</h5>
            </div>
            <!-- Start Tab Body -->
            <el-card
              v-else
              shadow="hover"
              v-for="(company, i) in listCompany"
              :key="i"
              :class="{
                'card-item': true,
                checked: company.value,
                'pointer-not-allow': company.not_change,
              }"
            >
              <b-form-checkbox
                v-model="company.value"
                @change="fn_toggleTagCompany(company)"
                :disabled="company.not_change"
                :class="{
                  'pointer-not-allow': company.not_change,
                }"
              >
                <el-avatar
                  :src="company.avt ? company.avt : 'img/company.jpg'"
                  class="ml-2 mr-2"
                ></el-avatar>
                <div>
                  <div class="d-flex align-items-center">
                    <p class="bold mb-1 text-overflow-380">
                      {{ company.Name.name_vi }}
                    </p>
                    <div
                      class="ml-2 d-flex align-items-center urgency urgent"
                      v-if="company.is_transfered"
                    >
                      <i class="icon isax-sms-tracking c-white mr-1"></i>
                      <p class="c-white">Đã nhận</p>
                    </div>
                  </div>
                </div>
              </b-form-checkbox>
            </el-card>
            <!-- Start Tab Body -->
          </el-tab-pane>
          <!-- End Tab CongTy -->

          <!-- Start Tab CaNhan -->
          <el-tab-pane name="CaNhan" v-if="listTagCompany.length > 0">
            <span slot="label">
              <div class="d-flex justify-content-center align-items-center">
                <i class="icon icon24-Profile mr-2"></i>
                <span>Chọn cá nhân</span>
              </div>
            </span>
            <div v-if="listVT.length == 0" class="text-center center-block">
              <h5 class="empty__tab-text">Không có dữ liệu.</h5>
            </div>
            <!-- Start Tab Body -->
            <el-card
              v-else
              shadow="hover"
              v-for="(emp, i) in listVT"
              :key="i"
              :class="{
                'card-item': true,
                checked: emp.value,
                'pointer-not-allow': emp.not_change,
              }"
            >
              <b-form-checkbox
                :data-id="`${emp.id}-${emp.position_id}`"
                v-model="emp.value"
                @change="fn_toggleTagPeopleTransfer(emp)"
                :disabled="emp.not_change"
                :class="{
                  'pointer-not-allow': emp.not_change,
                }"
              >
                <el-avatar
                  :src="emp.avt ? emp.avt : 'img/Vector-person.png'"
                  class="ml-2 mr-2"
                ></el-avatar>
                <div>
                  <div class="d-flex align-items-center">
                    <p class="bold mb-1 text-overflow-380">
                      {{ emp.administrative_info.name.full_name }}
                    </p>
                    <div
                      class="ml-2 d-flex align-items-center urgency urgent"
                      v-if="emp.is_transfered"
                    >
                      <i class="icon isax-sms-tracking c-white mr-1"></i>
                      <p class="c-white">Đã nhận</p>
                    </div>
                  </div>
                  <p>
                    <span
                      class="span__block-overflow"
                      :title="emp.employee_no"
                      >{{ emp.employee_no }}</span
                    >
                    •
                    {{
                      emp.administrative_info.phone_number
                        ? emp.administrative_info.phone_number
                        : "**** *** ***"
                    }}
                    {{ emp.position_name ? "• " + emp.position_name : "" }}
                  </p>
                </div>
              </b-form-checkbox>
            </el-card>
            <!-- Start Tab Body -->
          </el-tab-pane>
          <!-- End Tab CaNhan -->
        </el-tabs>
        <!-- End Tab -->
      </b-col>

      <b-col md="6" class="pr-0 right-side">
        <h6 class="bold mb-3">2. Nhập nội dung chuyển</h6>
        <el-input
          type="textarea"
          v-model="mData.dataFormTransferToOtherCompany.content"
          placeholder="Nhập nội dung"
          clearable
          show-word-limit
          maxlength="2000"
          @input="forceUpdateUI"
          resize="none"
        ></el-input>
      </b-col>
    </b-row>
    <b-row class="mb-3">
      <b-col md="7" class="p-0">
        <p class="bold mt-2" v-if="listTagCompany.length == 0">
          <span class="bold" style="font-size: 14px">Đến:</span>
          <span style="color: #7e7e7e"> "Vui lòng chọn 1 công ty"</span>
        </p>
        <b-row v-if="listTagCompany.length > 0">
          <div class="pl-0 pr-3" style="margin-top: 7px">
            <span class="bold">Đến công ty:</span>
          </div>
          <b-col class="p-0">
            <el-tag
              class="mb-2 mr-2"
              v-for="(tag, i) in listTagCompany"
              :key="i"
              :disable-transitions="false"
              :data-idd="tag.id"
              :title="`${tag.name}`"
            >
              <div
                class="d-flex justify-content-between align-items-center h-100"
              >
                <el-avatar
                  size="small"
                  :src="tag.avt ? tag.avt : 'img/company.jpg'"
                  class="ml-2 mr-2"
                ></el-avatar>
                <div class="d-flex align-items-center">
                  <p class="text-overflow-280 mr-1">{{ tag.name }}</p>
                </div>
                <i
                  v-if="$route.query.handle == 'transfer' || !tag.not_change"
                  class="el-tag__close el-icon-close"
                  @click="fn_closeTagCompany(tag)"
                ></i>
              </div>
            </el-tag>
          </b-col>
        </b-row>
        <b-row v-if="listTagPeopleTransfer.length > 0">
          <div class="pl-0 pr-3" style="margin-top: 7px">
            <span class="bold">Đến cá nhân:</span>
          </div>
          <b-col class="p-0">
            <el-tag
              class="mb-2 mr-2"
              v-for="(tag, i) in listTagPeopleTransfer"
              :key="i"
              :disable-transitions="false"
              :data-idd="tag.id"
              :title="`${
                tag.name +
                (tag.position_name ? ' (' + tag.position_name + ')' : '')
              }`"
            >
              <div
                class="d-flex justify-content-between align-items-center h-100"
              >
                <el-avatar
                  size="small"
                  :src="tag.avt ? tag.avt : 'img/Vector-person.png'"
                  class="ml-2 mr-2"
                ></el-avatar>
                <div class="d-flex align-items-center">
                  <p class="text-overflow-280 mr-1">{{ tag.name }}</p>
                  <p>{{ tag.position_name ? `(${tag.position_name})` : "" }}</p>
                </div>
                <i
                  v-if="$route.query.handle == 'transfer' || !tag.not_change"
                  class="el-tag__close el-icon-close"
                  @click="fn_closeTagPeopleTransfer(tag)"
                ></i>
              </div>
            </el-tag>
          </b-col>
        </b-row>
      </b-col>
      <b-col md="5" class="p-0">
        <!-- Start Manipulate button -->
        <div
          class="text-right pb-3 action__btn"
          :class="$route.query.handle != 'transfer' ? 'mt-3' : 'mt-5'"
        >
          <el-button
            v-if="viewMode == 'create'"
            class="btn__doc btn__doc-back"
            @click="fn_goBack"
            >Quay lại</el-button
          >
          <el-button
            :disabled="listTagCompany.length == 0"
            class="btn__doc btn__doc-transfer"
            @click="fn_submitForm()"
            >Chuyển văn bản</el-button
          >
        </div>
        <!-- End Manipulate button -->
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ExtensionService from "../../../service/ExtensionService";
import MethodService from "../../../service/MethodService";
import CompanyApi from "../../../moduleApi/CompanyApi";
import EmployeeApi from "../../../moduleApi/EmployeeApi";
import DocumentApi from "../../../moduleApi/DocumentApi";
import { dataDocMixins } from "../ElectronicDocument/DocumentMixins/dataDocMixins";
import { fnDocMixins } from "../ElectronicDocument/DocumentMixins/fnDocMixins";

export default {
  mixins: [dataDocMixins, fnDocMixins],
  data() {
    return {
      tabName: "CongTy",

      textFindGroup: "",
      listDocumentGroupFilter: [],
      listTagCompany: [],
      listTagPeopleTransfer: [],

      contentTransfer: "",
      listCompany: [],
      listVT: [],
    };
  },

  methods: {
    async fn_handleClickTab(tab, event) {
      this.tabName = tab.name;
      if (this.tabName == "CongTy") {
        this.$refs["formSearchCompany"].fields
          .find((f) => f.prop == "text_search_company")
          .clearValidate();
      } else if (this.tabName == "CaNhan") {
        this.$refs["formSearchPeople"].fields
          .find((f) => f.prop == "text_search_person")
          .clearValidate();
      }
    },

    async fn_getListCompany() {
      this.$refs["formSearchCompany"].validate(async (valid) => {
        if (!valid) {
          return;
        }
        try {
          const companyApiRes = await CompanyApi.SearchCompany(
            this.mData.dataFormTransferToOtherCompany.text_search_company
          );
          if (companyApiRes.result) {
            this.listCompany = await this.fn_changeCompanyData(
              companyApiRes.result
            );
            await this.fn_checkCompany();
          }
        } catch (error) {
          if (error.code == 402) {
            this.$notify.warning({
              message: `${error.detail}.`,
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          }
          this.$notify.warning({
            message: "Tìm kiếm thất bại.",
            duration: 3000,
            customClass: "doc-warning",
          });
        }
      });
    },

    fn_changeCompanyData(data) {
      data.forEach((company) => {
        company.value = false;
        company.avt = company.Logo_id
          ? ExtensionService.urlImg + company.Logo_id + "&r=square&w=512"
          : "";
      });
      return data;
    },

    async fn_getListVTByCompanyId() {
      this.$refs["formSearchPeople"].validate(async (valid) => {
        if (!valid) {
          return;
        }
        try {
          const dataSearch = {
            company_id: this.listTagCompany[0].id,
            text_search: this.mData.dataFormVTOtherCompany.text_search_person,
          };
          const employeeApiRes =
            await EmployeeApi.GetEmployeeIdsHaveVTRoleByCompanyId(dataSearch);
          if (employeeApiRes.result) {
            this.listVT = await this.fn_changeVTData(employeeApiRes.result);
            await this.fn_checkPeople();
          }
        } catch (error) {
          if (error.code == 402) {
            this.$notify.warning({
              message: `${error.detail}.`,
              duration: 3000,
              customClass: "doc-warning",
            });
            return;
          }
          this.$notify.warning({
            message: "Tìm kiếm thất bại.",
            duration: 3000,
            customClass: "doc-warning",
          });
        }
      });
    },

    fn_changeVTData(data) {
      data.forEach((e) => {
        e.avt = e.image_id
          ? ExtensionService.urlImg +
            e.administrative_info.avatar_id +
            "&r=square&w=512"
          : e.administrative_info.avatar_id
          ? ExtensionService.urlImg +
            e.administrative_info.avatar_id +
            "&r=square&w=512"
          : "";
        const pos = this.mData.dataDefault.listPosition.find(
          (p) => p.id == e.job_info[0].position_id
        );
        e.position_name = pos && pos.name ? pos.name : "";
      });
      return data;
    },

    async fn_getListDataByTab(isSearch) {
      if (this.tabName == "CongTy") {
        await this.fn_getListCompany();
      } else if (this.tabName == "CaNhan") {
        await this.fn_getListVTByCompanyId();
      }
    },

    fn_closeTagCompany(tag) {
      this.listCompany.forEach((company) => {
        if (company.id == tag.Id) {
          company.value = false;
          return;
        }
      });
      this.listTagCompany.splice(this.listTagCompany.indexOf(tag), 1);
      this.tabName = "CongTy";
      this.mData.dataFormVTOtherCompany.text_search_person = "";
      this.listTagPeopleTransfer = [];
      this.listVT = [];
    },

    fn_closeTagPeopleTransfer(tag) {
      this.listVT.forEach((person) => {
        if (person.id == tag.id) {
          person.value = false;
          return;
        }
      });
      this.listTagPeopleTransfer.splice(
        this.listTagPeopleTransfer.indexOf(tag),
        1
      );
    },

    fn_toggleTagCompany(target) {
      const isDuplicate = this.listTagCompany.find((e) => e.id == target.Id);
      if (target.value && !isDuplicate) {
        if (this.listTagCompany.length > 0) {
          this.$notify.info({
            message: "Vui lòng bỏ chọn công ty hiện tại để chọn công ty khác.",
            duration: 3000,
            customClass: "doc-info",
          });
          const index = this.listCompany.findIndex((c) => c.Id == target.Id);
          this.listCompany[index].value = false;
          return;
        }
        if (target.Disabled) {
          this.$notify.info({
            message: "Công ty này đã bị khóa. Không thể chuyển văn bản.",
            duration: 3000,
            customClass: "doc-info",
          });
          const index = this.listCompany.findIndex((c) => c.Id == target.Id);
          this.listCompany[index].value = false;
          return;
        }
        this.listTagPeopleTransfer = [];
        this.listVT = [];
        this.mData.dataFormVTOtherCompany.text_search_person = "";
        this.listTagCompany.push({
          id: target.Id,
          name: target.Name ? target.Name.name_vi : "",
          avt: target.avt,
        });
      } else if (!target.value && isDuplicate) {
        // Toggle at listTag
        this.listTagCompany = this.listTagCompany.filter(
          (tag) => tag.id != target.Id
        );
        this.listTagPeopleTransfer = [];
        this.listVT = [];
        this.mData.dataFormVTOtherCompany.text_search_person = "";
      }
    },

    fn_toggleTagPeopleTransfer(target) {
      const isDuplicate = this.listTagPeopleTransfer.find(
        (e) => e.id == target.id
      );
      if (target.value && !isDuplicate) {
        if (
          this.listTagPeopleTransfer &&
          this.listTagPeopleTransfer.length > 0
        ) {
          this.$notify.info({
            message: "Vui lòng bỏ chọn cá nhân hiện tại để chọn cá nhân khác.",
            duration: 3000,
            customClass: "doc-info",
          });
          const index = this.listVT.findIndex((p) => p.id == target.id);
          this.listVT[index].value = false;
          return;
        }
        this.listTagPeopleTransfer.push({
          id: target.id,
          name:
            target.administrative_info && target.administrative_info.name
              ? target.administrative_info.name.full_name
              : "",
          position_name: target.position_name ? target.position_name : "",
          avt: target.avt,
        });
      } else if (!target.value && isDuplicate) {
        this.listTagPeopleTransfer = this.listTagPeopleTransfer.filter(
          (tag) => tag.id != target.id
        );
      }
    },

    fn_checkCompany() {
      this.listCompany.forEach((c1) => {
        this.listTagCompany.forEach((c2) => {
          if (c1.Id == c2.id) {
            c1.value = true;
          }
        });
      });
    },

    fn_checkPeople() {
      this.listVT.forEach((p1) => {
        this.listTagPeopleTransfer.forEach((p2) => {
          if (p1.id == p2.id) {
            p1.value = true;
          }
        });
      });
    },

    async fn_getDocById() {
      const documentInApiRes = await DocumentApi.findById(
        this.$route.params.id
      );
      if (documentInApiRes.result) {
        this.mData.dataForm = documentInApiRes.result;
        this.fn_eventBus(
          this.checkTab(this.$route.query.type),
          "transfer",
          this.mData.dataForm.name
        );
      }
    },

    async fn_submitForm() {
      try {
        const res = await DocumentApi.findById(this.$route.params.id);
        if (res.result && res.result.status == "TRANSFERED_OTHER_COMPANY") {
          this.$notify.info({
            message: `Văn bản này hiện đã được chuyển sang công ty khác.`,
            duration: 3000,
            customClass: "doc-info",
          });
          this.fn_goBack();
          return;
        }
        const dataTransfer = {
          id: this.$route.params.id,
          other_company_id:
            this.listTagCompany.length > 0 && this.listTagCompany[0].id,
          transfer_ids:
            this.listTagPeopleTransfer.length > 0 &&
            this.listTagPeopleTransfer[0].id
              ? [this.listTagPeopleTransfer[0].id]
              : [],
          content: this.mData.dataFormTransferToOtherCompany.content
            ? this.mData.dataFormTransferToOtherCompany.content.trim()
            : "",
        };
        const documentInApiRes =
          await DocumentApi.TransferDocumentForOtherCompany(dataTransfer);
        if (documentInApiRes.result) {
          this.$notify.success({
            message: "Chuyển văn bản thành công.",
            duration: 3000,
            customClass: "doc-success",
          });
          await this.fn_goToList();
        }
      } catch (error) {
        // console.log(error);
        if (error.code == 404) {
          this.$notify.warning({
            message: `${error.detail}. Vui lòng chọn cá nhân để chuyển văn bản.`,
            duration: 3000,
            customClass: "doc-warning",
          });
          return;
        }
        this.$notify.warning({
          message: "Chuyển văn bản thất bại.",
          duration: 3000,
          customClass: "doc-warning",
        });
      }
    },

    async fn_initData() {
      this.fn_getListPosition();
      await this.fn_getDocById();
    },
  },

  created() {
    this.fn_eventBus(this.checkTab(this.$route.query.type));
    this.fn_initData();
  },
};
</script>

<style lang="scss" scoped>
.urgency {
  padding: 3px 6px;
  border-radius: 4px;
  color: white;
  text-align: center;
  &.high-urgency {
    background-color: #f12727;
  }
  &.urgent {
    background-color: #ff5621;
  }
  &.express {
    background: transparent;
    border: 1px solid #ff5621;
    color: #ff5621;
  }
}
::v-deep .empty__tab-text {
  color: #b3b3b3;
}
.checked {
  background: #d0e8f5 !important;
}
::v-deep .el-input__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
}
::v-deep .el-checkbox {
  .el-checkbox__input.is-checked {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__input.is-focus {
    .el-checkbox__inner {
      border-color: var(--turquoise) !important;
    }
  }
  .el-checkbox__input.is-indeterminate {
    .el-checkbox__inner {
      background-color: var(--turquoise);
      border-color: var(--turquoise);
    }
  }
  .el-checkbox__inner {
    width: 16px;
    height: 16px;
    border-radius: 4px;
    border-color: var(--turquoise);
    top: 3px;
    &:hover {
      border-color: var(--turquoise) !important;
    }
    &:focus {
      border-color: var(--turquoise) !important;
    }
    &:active {
      border-color: var(--turquoise) !important;
    }
  }
}
::v-deep .el-textarea__inner {
  border-radius: 0;
  box-shadow: none !important;
  border-radius: 5px !important;
  height: calc(100vh - 275px);
}
::v-deep .el-input__prefix {
  .el-input__icon.fa-search {
    margin-left: 7px;
  }
}
::v-deep .el-tabs__content {
  overflow: auto;
  .el-tab-pane {
    height: calc(100vh - 415px);
    .center-block {
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
    }
  }
}
::v-deep .el-tabs__item {
  border-radius: 0;
  background-color: #e9e9e9;
  span {
    color: black;
  }
}
::v-deep .el-tabs__nav {
  &:not(.is-active)::after {
    content: "";
    position: absolute;
    bottom: 0px;
    right: 0px;
    width: 100%;
    height: 2px;
    background: #d0d5d9;
  }
}
::v-deep .el-tabs--border-card > .el-tabs__header {
  .el-tabs__item {
    font-size: 13px;
    border-top: 2px solid transparent;
    margin: 0;
    position: relative;

    &:not(:last-child)::before {
      content: "";
      position: absolute;
      top: 5px;
      right: -1px;
      width: 1px;
      height: 75%;
      background: #7e7e7e;
    }
  }
  .el-tabs__item.is-active {
    border-top: 2px solid var(--orange) !important;
    border-left: none;
    span {
      color: black;
      font-weight: bold;
    }
    &::after {
      content: "";
      position: absolute;
      bottom: -1px;
      right: 0px;
      width: 100%;
      height: 2px;
      background: #fff;
      z-index: 1000;
    }
  }
}
::v-deep .icon {
  cursor: pointer;
  font-size: 21px;
}
::v-deep .isax-trash {
  color: var(--red);
}
::v-deep .isax-eye {
  color: var(--orange);
}
::v-deep .el-upload-dragger {
  height: 36px;
}
::v-deep .el-upload {
  position: relative;
}
::v-deep .el-upload__tip {
  position: absolute;
  top: 5px;
  left: 150px;
  font-style: italic;
  color: #606266;
  margin-top: 0;
}
::v-deep .el-dialog__body {
  padding: 0px !important;
}
::v-deep .el-dialog__header {
  background-color: #fff !important;
  border-bottom: 1px solid #fff !important;
}
::v-deep .datePicker .el-input__prefix,
.el-input__suffix {
  right: 5px;
  left: auto;
}
::v-deep .el-input--suffix .el-input__inner {
  padding-left: 15px;
  padding-right: 15px;
}
::v-deep .el-tag {
  border: none;
  border-radius: 8px;
  background-color: #d0e8f5;
  .el-avatar--small {
    width: 23px;
    height: 23px;
    line-height: 28px;
  }
  .el-icon-close {
    color: var(--black);
    top: 0;
    &:hover {
      color: var(--white);
    }
  }
}
::v-deep .el-tag--small {
  height: 36px;
}
::v-deep .el-date-editor.el-input {
  width: 220px;
}
::v-deep svg path,
svg rect {
  fill: #ccc !important;
}
::v-deep .vue-treeselect__control {
  position: fixed;
  top: 170px;
  left: 140px;
  width: 40%;
  border: none;
  .vue-treeselect__placeholder {
    font-family: "LexendDeca Regular", sans-serif;
    font-size: 14px;
    font-weight: 500;
    padding: 1px 0px 1px 6px;
  }
  .vue-treeselect__multi-value-item {
    display: none;
  }
}
::v-deep .vue-treeselect__menu-container {
  .vue-treeselect__menu {
    border: none;
    height: auto;
    box-shadow: none;
    max-height: none !important;
  }
}
@media (min-width: 1366px) {
  ::v-deep .el-tabs__nav {
    width: 100%;
    .el-tabs__item {
      width: 25%;
    }
  }
  ::v-deep .right-side {
    .el-textarea {
      .el-input__count {
        right: 4px;
        bottom: 0px;
      }
    }
  }
}
/*Ipad dọc(768 x 1024)*/
@media (max-width: 768px){
  ::v-deep .right-side {
    h6 {
      margin-bottom: 30px !important;
    }
  }
  ::v-deep .action__btn {
    margin-top: 0 !important;
    .btn__doc-back {
      margin-bottom: 10px;
    }
  }
}
</style>
